<template>
  <div class="team row row--hover box box--default">
    <div
        class="row__data row__data--small row__data--image team__logo"

    >
      <img v-if="userThumbnail" :src="userThumbnail" alt="" />
      <div v-else class="thumbnail thumbnail--team" :style="color">
        {{ parseInitials(team.name) }}
      </div>
    </div>
    <div
      class="row__data row__data--large row__data--name"
     
    >
      {{ team.name }}
    </div>

    <div
      class="row__data row__data--medium"
     
    >
      {{ team.finma_nr || '-' }}
    </div>

    <div
      class="row__data row__data--medium"
     
    >
      {{ team.domain || '-' }}
    </div>

    <div
      class="row__data row__data--large row__data--address"
     
    >
      {{ fullAddress }}
    </div>

    <div
      class="row__data row__data--large team__mandates"
      style="justify-content: flex-start;"
    >
      <div v-if="team.mandate_types && team.mandate_types.length > 0" class="mandates-list">
        <div v-for="mandateType in team.mandate_types" :key="mandateType.id" class="mandate-item">
          {{ mandateType.name }}
        </div>
      </div>
      <span v-else>-</span>
    </div>

    <div
      class="row__data row__data--action row__data--small"
      @click.self="showActionsDropdown = !showActionsDropdown"
      v-if="$checkRolePermission('team_delete')"
    >
      <TeamsRowActionDropdown
        v-if="showActionsDropdown"
        @toggleDropdown="showActionsDropdown = $event"
        :onEdit="editTeam"
        :onDelete="removeTeam"
        :onTaxes="taxes"

      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import TeamsRowActionDropdown from "@/components/TeamsActionDropdown";
import { parseInitials } from "@/helpers/entityParsers";

defineOptions({
  name: "Team"
});

const props = defineProps({
  team: {
    required: true,
    type: Object,
  },
  deleteTeam: {
    required: true,
    type: Function,
  },
});

const store = useStore();
const router = useRouter();

// State
const showActionsDropdown = ref(false);

// Computed
const userThumbnail = computed(() => 
  props.team.photo ? props.team.photo.thumbnail : null
);

const color = computed(() => 
  props.team.color 
    ? { background: props.team.color } 
    : { background: "#7f8fa4" }
);

const fullAddress = computed(() => {
  const parts = [];
  if (props.team.street) parts.push(props.team.street);
  if (props.team.number) parts.push(props.team.number);
  const streetAddress = parts.join(' ');
  
  const cityParts = [];
  if (props.team.zip) cityParts.push(props.team.zip);
  if (props.team.city) cityParts.push(props.team.city);
  const cityAddress = cityParts.join(' ');
  
  const fullParts = [];
  if (streetAddress) fullParts.push(streetAddress);
  if (cityAddress) fullParts.push(cityAddress);
  
  return fullParts.length > 0 ? fullParts.join(', ') : '-';
});

// Methods
const editTeam = () => {
  store.commit("setTeamToEdit", props.team);
  store.commit("setTeamIsEdit", true);
  store.commit("setShowAddTeamModal", true);
};

const removeTeam = () => {
  props.deleteTeam({
    display: true,
    message: `'${props.team.name}'`,
    action: store._actions.deleteTeam,
    id: props.team.id,
  });
};

const taxes = () => {
  router.push({
    name: "TeamTaxes",
    params: {
      id: props.team.id,
    },
  });
};
</script>

<style scoped lang="scss">
.row__data--action {
  max-width: 70px;
}

.team__logo{
  max-width: 70px;
}

.team__mandates {
  align-items: flex-start !important;
  text-align: left !important;
  
  .mandates-list {
    max-height: 60px;
    overflow-y: auto;
    width: 100%;
    
    &::-webkit-scrollbar {
      width: 4px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: var(--color-9, #ccc);
      border-radius: 2px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: var(--color-8, #999);
    }
  }
  
  .mandate-item {
    padding: 2px 0;
    line-height: 1.4;
    font-size: 13px;
    text-align: left;
  }
}
</style>